/**
 * Textarea widget.
 */

import type { FunctionComponent } from 'preact'

interface TextAreaProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  rows?: number
}

export const TextArea: FunctionComponent<TextAreaProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  rows = 4,
}) => {
  return (
    <textarea
      class="syv-input syv-textarea"
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      rows={rows}
      onInput={(e) => onChange((e.target as HTMLTextAreaElement).value)}
    />
  )
}
